import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { Section, Heading, Eyebrow } from '../Section';
import { SectionCTA } from '../SectionCTA';
import { bonos } from '../../data/content';
export function Bonos() {
  return <Section tone="soft" data-id="element-116" data-mp="1hhofgh0bu5qd">
      <Eyebrow data-id="element-117" data-mp="1ckxtjd1ucfx1">Kit Profesional de Consulta</Eyebrow>
      <Heading data-id="element-118" data-mp="1cl7m98e9t16f">
        Además recibirás 5 herramientas clínicas completamente{' '}
        <span className="italic text-brand" data-id="element-119" data-mp="ovve8buoiz5p">GRATIS</span>
      </Heading>
      <p className="mx-auto mt-4 max-w-lg text-center text-[14.5px] leading-relaxed text-navy/70 sm:text-base" data-id="element-120" data-mp="jwinhg0ot7xu">
        Porque tomar buenas decisiones también depende de tener las herramientas correctas en el
        momento adecuado.
      </p>

      <div className="mt-8 space-y-4" data-id="element-121" data-mp="tsvjwlnm9zwa">
        {bonos.map((bono, i) => <motion.article key={bono.number} initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.45,
        ease: 'easeOut',
        delay: i % 2 * 0.05
      }} className="overflow-hidden rounded-3xl border border-navy/10 bg-white" data-id="element-122" data-mp="63axttw62mis" data-mpi={i}>
            {bono.image && <img src={bono.image} alt={`Vista previa del bono ${bono.number}: ${bono.title}`} className="w-full bg-cream object-contain" loading="lazy" data-id="element-123" data-mp="390qu3llxb7oq" />}

            <div className="p-4 sm:p-5" data-id="element-124" data-mp="2lacyxm81kspx">
              <p className="flex items-center gap-2 text-[11.5px] font-extrabold uppercase tracking-[0.18em] text-brand" data-id="element-125" data-mp="2lbfptu5d6v5u">
                <GiftIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-126" data-mp="2pawy0vc6e6ep" />
                Bono #{bono.number}
              </p>

              <h3 className="mt-2 text-balance font-serif text-[19px] font-extrabold leading-tight text-navy sm:text-[23px]" data-id="element-127" data-mp="4m0p5h2lx633">
                {bono.title}
              </h3>
              <p className="mt-2 text-[14px] leading-relaxed text-navy/70 sm:text-[15px]" data-id="element-128" data-mp="9n6klmnnj7gb">
                {bono.description}
              </p>

              <div className="mt-3.5 flex flex-wrap items-center gap-2" data-id="element-129" data-mp="21neocx6d71fj">
                <span className="rounded-full bg-cream-dark px-2.5 py-1 text-[12px] font-bold text-navy/50 line-through" data-id="element-130" data-mp="2fmeb1zabh692">
                  Valor: {bono.value}
                </span>
                <span className="rounded-full bg-good px-2.5 py-1 text-[12px] font-extrabold uppercase tracking-wide text-white" data-id="element-131" data-mp="2al8m8cjs234t">
                  Hoy gratis
                </span>
              </div>
            </div>
          </motion.article>)}
      </div>

      <div className="mt-8 rounded-3xl bg-navy p-5 text-center sm:p-7" data-id="element-132" data-mp="1wobtg5k3mbla">
        <p className="font-serif text-[21px] font-extrabold leading-snug text-white sm:text-3xl" data-id="element-133" data-mp="1rwk1bqlanxt1">
          Hoy no estás comprando PDFs.
        </p>
        <p className="mx-auto mt-3 max-w-md text-[14.5px] leading-relaxed text-white/75 sm:text-base" data-id="element-134" data-mp="14568ljj8e07j">
          Estás obteniendo un sistema que puede acompañarte durante cientos de consultas.
        </p>
        <div className="mx-auto mt-5 grid max-w-sm grid-cols-2 gap-2" data-id="element-135" data-mp="3atez32ru5u2k">
          {['Cada algoritmo.', 'Cada protocolo.', 'Cada checklist.', 'Cada herramienta.'].map(item => <p key={item} className="rounded-xl bg-white/[0.07] px-3 py-2.5 text-[13px] font-bold text-white/90" data-id="element-136" data-mp="31sqka5umbpom">
                {item}
              </p>)}
        </div>
        <p className="mx-auto mt-5 max-w-md text-[14px] leading-relaxed text-white/70" data-id="element-137" data-mp="2g7z3d2di8fv">
          Fue diseñado para ayudarte a tomar decisiones con mayor rapidez y seguridad cuando realmente
          importa: <strong className="font-bold text-white" data-id="element-138" data-mp="3pjw8p9emjqaj">frente al paciente</strong>.
        </p>
      </div>

      <SectionCTA promise="USD $140 en herramientas clínicas incluidas sin costo, solo hoy." label="Quiero el sistema + los 5 bonos" data-id="element-139" data-mp="295mjkd2k5xin" />
    </Section>;
}